// ./src/components/features/Dashboard/DashboardAlerts.tsx
import React from "react";
import { Stack, Alert, Text, Group } from "@mantine/core";

import { AppButton, AppIcon } from "@/components/generic";
import { DashboardAlertItem } from "@/utils/api";

// Alert severity colors
const ALERT_COLORS: Record<string, string> = {
  error: "red",
  warning: "yellow",
  info: "blue",
};

// Alert icons
const ALERT_ICONS: Record<string, string> = {
  error: "AlertCircle",
  warning: "AlertTriangle",
  info: "Info",
};

export interface DashboardAlertsProps {
  alerts: DashboardAlertItem[];
  onNavigateToForm: (formId: string) => void;
}

export const DashboardAlerts: React.FC<DashboardAlertsProps> = ({
  alerts,
  onNavigateToForm,
}) => {
  if (alerts.length === 0) {
    return null;
  }

  return (
    <Stack gap="xs">
      {alerts.map((alert, index) => (
        <Alert
          key={`${alert.type}-${index}`}
          color={ALERT_COLORS[alert.severity] || "gray"}
          variant="light"
          icon={
            <AppIcon iconName={ALERT_ICONS[alert.severity] as any} size={16} />
          }
          title={null}
        >
          <Group justify="space-between" align="center">
            <Text size="sm">{alert.message}</Text>
            {alert.formId && (
              <AppButton
                variant="secondary"
                size="xs"
                onClick={() => onNavigateToForm(alert.formId!)}
              >
                View Form
              </AppButton>
            )}
          </Group>
        </Alert>
      ))}
    </Stack>
  );
};
